import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[scheda_esecuzione_entity_view]',
  templateUrl: 'scheda-esecuzione-entity-view.component.html',
})

export class SchedaEsecuzioneEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element;
}
